import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/sl'
import 'dayjs/locale/en'

dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)

export const setDayjsLocale = (locale: string) => {
    dayjs.locale(locale === 'sl' ? 'sl' : 'en')
}

export const formatDateTime = (value?: string | null): string => {
    if (!value) return '—'
    return dayjs(value).format('L LT')
}

export const formatDate = (value?: string | null): string => {
    if (!value) return '—'
    return dayjs(value).format('L')
}

export const fromNow = (value?: string | null): string => {
    if (!value) return '—'
    return dayjs(value).fromNow()
}

// Whole hours left, rounded up so a link with 40 minutes on it still reads "1 h" rather
// than "0 h". Zero once it is spent.
export const hoursUntil = (value?: string | null): number => {
    if (!value) return 0
    return Math.max(0, Math.ceil(dayjs(value).diff(dayjs(), 'minute') / 60))
}

export const daysUntil = (value?: string | null): number => {
    if (!value) return 0
    return Math.max(0, dayjs(value).diff(dayjs(), 'day'))
}

export default dayjs
